<script lang="ts">
	import type { Category, InventoryType, SearchField } from 'utility/search-fields'
	import type { ComponentProps } from 'svelte'
	import type { SvelteSet } from 'svelte/reactivity'

	import CategoryAutocomplete from './CategoryAutocomplete.svelte'
	import EditModeControls from './EditModeControls.svelte'
	import Pin from './Pin.svelte'

	interface Props extends Omit<ComponentProps<typeof CategoryAutocomplete>, 'value' | 'options' | 'getLabel'> {
		searchField: SearchField
		category?: Category | null
		initialValue?: string
		inventoryType: InventoryType | null
		inEditMode: boolean
		pinnedSearchFields: SvelteSet<SearchField['key']> //Required
		selectedSearchFieldsKeys: SvelteSet<SearchField['key']> //Required
		disabled?: boolean
	}

	let {
		searchField,
		category = $bindable(null),
		initialValue,
		inventoryType,
		inEditMode,
		pinnedSearchFields = $bindable(),
		selectedSearchFieldsKeys = $bindable(),
		disabled = false,
		...rest
	}: Props = $props()
</script>

<EditModeControls
	{searchField}
	{inEditMode}
	{pinnedSearchFields}
	{selectedSearchFieldsKeys}
>
	<CategoryAutocomplete
		{...rest}
		{initialValue}
		{inventoryType}
		disabled={inEditMode || disabled}
		bind:category
	>
		{#snippet hint()}
			<Pin isPinned={pinnedSearchFields.has(searchField.key)} />
		{/snippet}
	</CategoryAutocomplete>
</EditModeControls>
